import { apiClient } from '@api/apiClient';
import { V4ApiResponse } from '@api/types';
import { buildChangeTrackingRequestConfig } from '@changeTracking/utils/buildChangeTrackingHeaders';
import { ToastType } from '@components/Toast';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';
import { createError } from '@utils/errorUtils';
import { handlePopupToast, handleToast } from '@utils/utils';

import { CustomerContract } from './types';

const fetchCustomerContracts = async (customerId: string, cb?: () => void) => {
  try {
    const response: V4ApiResponse<CustomerContract> = await apiClient.get(
      `/Customer/Contracts/${customerId}?toCurrency=NAN`,
    );
    if ('value' in response) {
      return response.value;
    }
  } catch (error) {
    const e = createError(error, 'Failed to fetch customer contracts');
    handleToast(ToastType.Error, e.message);
  } finally {
    cb && cb();
  }
};

const updateCustomerContractCall = async (
  customerContract: CustomerContract,
  changeTrackingSources: ChangeTrackingSource[] = [],
) => {
  try {
    await apiClient.post(
      '/Customer/contracts',
      customerContract,
      buildChangeTrackingRequestConfig(changeTrackingSources),
    );
    handlePopupToast(
      ToastType.Success,
      'Customer contracts updated successfully',
    );
    return true;
  } catch (error) {
    const e = createError(error, 'Failed to update customer contracts');
    handleToast(ToastType.Error, e.message);
    return false;
  }
};

export { fetchCustomerContracts, updateCustomerContractCall };
